import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/operations/multiplier')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/operations/multiplier']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
